<div class="mb-3 row">
    <div class="row" *ngIf="headerMsg">
        <div class="p-fluid">
            <p>{{headerMsg}}</p>
        </div>
    </div>
    <div class="d-flex align-items-start justify-content-start"> &nbsp;
        <button class="btn btn-primary" (click)="addProp()">
            <i class="fas fa-plus"></i> Add Property
        </button>
    </div>
    <div class="p-fluid">
        <div *ngIf="props" [formGroup]="searchForm">
            <div [formArrayName]="instanceName">
                <div *ngFor="let control of props.controls; let i = index;">
                    <div [formGroupName]="i">
                        <div *ngIf="props.length > 1">
                            <hr />
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 col-sm-3">
                                <select class="form-select p-2" formControlName="propertyItem"
                                    (change)="selectedProp(i)" aria-Label="Select Document Property">
                                    <option selected class="dropdown-select" value="">
                                        --Select Property--
                                    </option>
                                    <option class="dropdown-select" *ngFor="let a of mdItems" value="{{ a.id }}">
                                        {{ a.displayName }}
                                    </option>
                                </select>
                                 <a class="mt-5" href="https://www.nrc.gov/reading-rm/adams/help-reference.html#ListofLicenses" target="_blank">Docket Number Lookup</a>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div *ngIf="control.value.isDate">
                                    <div class="row mb-2">
                                        <select class="flex align-items-start me-2 form-select "
                                            formControlName="dateOperator" (change)="toggleDateOp(i)"
                                            aria-Label="Date Operator">
                                            <option selected class="dropdown-select"
                                                [value]="this.constants.date_operator_between">Between
                                            </option>
                                            <option class="dropdown-select"
                                                [value]="this.constants.date_operator_greater">On or After
                                            </option>
                                            <option class="dropdown-select" [value]="this.constants.date_operator_less">
                                                On or Before
                                            </option>
                                            <option class="dropdown-select"
                                                [value]="this.constants.date_operator_equals">Equals</option>
                                        </select>
                                    </div>
                                    <div class="row">
                                        <!-- Display time to the side of the date -->
                                        <div *ngIf="control.value.dateOperator !== 'between'" class="px-0 col-sm-12">
                                            <div class="row">
                                                <div class="col-sm-8">
                                                    <input type="date" class="form-control form-control"
                                                        formControlName="startDate" id="startDate" aria-Label="Start Date"
                                                        placeholder="Start" />
                                                </div>
                                                <div class="col-sm-4">
                                                    <!-- *ngIf="selectedPropertyName == dateAddedPropId" -->
                                                        <select class="flex align-items-start form-select"
                                                    formControlName="startTime" aria-Label="Start Time">
                                                        <option value="" disabled selected>{{ timePlaceholder }}</option>
                                                        <option *ngFor="let t of timeIntervals" [value]="t">
                                                            {{ t }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Stack the date time -->
                                        <div *ngIf="control.value.dateOperator == 'between'" class="px-0 col-sm-12">
                                            <div class="row">
                                                <div class="col-sm-5">
                                                    <input type="date" class="form-control form-control"
                                                        formControlName="startDate" id="startDate" aria-Label="Start Date"
                                                        placeholder="Start" />
                                                        <!-- *ngIf="selectedPropertyName == dateAddedPropId"  -->
                                                    <select class="flex align-items-start mt-2 form-select"
                                                    formControlName="startTime" aria-Label="Start Time">
                                                        <option value="" selected>{{ timePlaceholder }}</option>
                                                        <option *ngFor="let t of timeIntervals" [value]="t">
                                                            {{ t }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-2">
                                                    <span class="form-label text-center">To</span>
                                                </div>
                                                <div class="col-sm-5">
                                                    <input type="date" class="form-control form-control"
                                                        formControlName="endDate" id="endDate" aria-Label="End Date"
                                                        placeholder="End" />
                                                    <select class="flex align-items-start mt-2 form-select"
                                                    formControlName="endTime" aria-Label="Start Time">
                                                        <option value="" selected>{{ timePlaceholder }}</option>
                                                        <option *ngFor="let t of timeIntervals" [value]="t">
                                                            {{ t }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div *ngIf="control.value.dateOperator == 'between'" class="col-sm-5">
                                            <input type="date" class="form-control form-control"
                                                formControlName="startDate" id="startDate" aria-Label="Start Date"
                                                placeholder="Start" />
                                            <select class="flex align-items-start mt-2 form-select"
                                            formControlName="startTime" aria-Label="Start Time">
                                                <option *ngFor="let t of timeIntervals" [value]="t">
                                                    {{ t }}
                                                </option>
                                            </select>
                                        </div>
                                        <div *ngIf="control.value.dateOperator == 'between'" class="col-sm-2">
                                            <span class="form-label text-center">To</span>
                                        </div>
                                        <div *ngIf="control.value.dateOperator == 'between'" class="col-sm-5">
                                            <input type="date" class="form-control form-control"
                                                formControlName="endDate" id="endDate" aria-Label="End Date"
                                                placeholder="End" />
                                              <select class="flex align-items-start mt-2 form-select"
                                            formControlName="endTime" aria-Label="Start Time">
                                                <option *ngFor="let t of timeIntervals" [value]="t">
                                                    {{ t }}
                                                </option>
                                            </select>
                                        </div> -->
                                    </div>
                                </div>
                                <div *ngIf="!control.value.isDate">
                                    <span class="p-fluid">
                                        <select class="flex align-items-start mb-2 form-select"
                                            formControlName="textOperator" (change)="toggleDateOp(i)"
                                            aria-Label="Text Operator">
                                            <option class="dropdown-select"
                                                [value]="this.constants.text_operator_starts">Starts With
                                            </option>
                                            <option class="dropdown-select"
                                                [value]="this.constants.text_operator_starts_not">Does Not Start With
                                            </option>
                                            <option selected class="dropdown-select"
                                                [value]="this.constants.text_operator_contains">Contains
                                            </option>
                                             <option selected class="dropdown-select"
                                                [value]="this.constants.text_operator_contains_not">Does Not Contain
                                            </option>
                                            <option class="dropdown-select"
                                                [value]="this.constants.text_operator_equals">Equals
                                            </option>
                                             <option class="dropdown-select"
                                                [value]="this.constants.text_operator_equals_not">Does Not Equal
                                            </option>
                                        </select>
                                        <p-autoComplete placeholder="Enter search term(s) for property"
                                            formControlName="keywords" ariaLabel="Keywords" [minLength]="2"
                                            [suggestions]="aFacetSugs"
                                            (completeMethod)="getPropSuggestions($event, control.value.propertyItem, control.value.textOperator)">
                                            <ng-template let-item pTemplate="item">
                                                <div pTooltip="{{ item }}" tooltipPosition="top">{{ item }}</div>
                                            </ng-template>
                                        </p-autoComplete>
                                        <div class="text-danger small mt-1" *ngIf="propertyKeywordLengthError(control)">
                                            Please enter at least 3 characters or leave the field empty.
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 col-sm-2">
                                <div class="row">
                                    <div class="col-12">
                                        <!-- <button type="button" class="btn btn-primary w-100 mb-2 mt-2" (click)="clearProp(i)">
                                            <i class="fas fa-circle-xmark"></i> Clear
                                        </button> -->
                                        <button type="button" class="btn  btn-primary w-100 mb-2"
                                            (click)="removeProp(i)"><i class="fas fa-trash"></i>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
